import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const purchases = [{
  name: 'María D.',
  city: 'Mar del Plata',
  product: 'Protocolo Rescate SIBO™',
  time: 13
}, {
  name: 'Valeria G.',
  city: 'Buenos Aires',
  product: 'Protocolo + Reset Metabólico',
  time: 8
}, {
  name: 'Claudia M.',
  city: 'Córdoba',
  product: 'Protocolo Rescate SIBO™',
  time: 22
}, {
  name: 'Natalia P.',
  city: 'Rosario',
  product: 'Protocolo + Reset Metabólico',
  time: 5
}, {
  name: 'Diana F.',
  city: 'Mendoza',
  product: 'Protocolo Rescate SIBO™',
  time: 31
}, {
  name: 'Luciana R.',
  city: 'Tucumán',
  product: 'Protocolo Rescate SIBO™',
  time: 17
}, {
  name: 'Sofía T.',
  city: 'La Plata',
  product: 'Protocolo + Reset Metabólico',
  time: 3
}, {
  name: 'Carolina B.',
  city: 'Santa Fe',
  product: 'Protocolo Rescate SIBO™',
  time: 45
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show first popup after 40 seconds, then every 40 seconds
    const showInterval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }, 40000);
    return () => clearInterval(showInterval);
  }, []);
  const purchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-287">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-288">
          <div className="bg-[#1a1a1a] border border-green-800/50 rounded-lg px-4 py-3 shadow-xl shadow-black/40" data-id="element-289">
            <div className="flex items-center gap-1.5 mb-1.5" data-id="element-290">
              <CheckCircleIcon className="w-4 h-4 text-green-500" data-id="element-291" />
              <span className="text-green-500 text-xs font-bold uppercase tracking-wider" data-id="element-292">
                Compra verificada
              </span>
            </div>
            <p className="text-white text-sm font-semibold" data-id="element-293">
              {purchase.name} de {purchase.city}
            </p>
            <p className="text-gray-300 text-sm" data-id="element-294">
              compró{' '}
              <span className="font-medium text-white" data-id="element-295">{purchase.product}</span>
            </p>
            <p className="text-gray-500 text-xs mt-1" data-id="element-296">
              hace {purchase.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}